import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { sortMethods } from 'Root/../../shared/sorting'
import RemarksService from 'Services/remarks'

import { Text, FadedText } from 'Components/shared/Typography'

const EventsContainer = styled.div`
  margin-top: 1em;
  overflow-y: auto;
  max-height: 155px;
`

const Events = styled.div`
  display: table;
  border-spacing: 0 5px;
`

const EventsRow = styled.div`
  display: table-row;
`

const EventsCell = styled.div`
  display: table-cell;
`

export default ({ encounter }) => {
  const [events, setEvents] = useState()

  useEffect(async () => {
    const allEvents = await RemarksService.get({ encounterId: encounter.id, type: 'events' })
    allEvents.sort((a, b) => sortMethods.date(a.date, b.date))
    setEvents(allEvents)
  }, [encounter])

  return (
    <EventsContainer>
      <Events>
        {events?.map(item => (
          <EventsRow>
            <EventsCell style={{ whiteSpace: 'nowrap' }}>
              <FadedText small>
                {new Intl.DateTimeFormat('en', {
                  year: 'numeric',
                  month: 'numeric',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: 'numeric'
                }).format(new Date(item.date))}
              </FadedText>
            </EventsCell>
            <EventsCell
              style={{
                'padding-left': '2em'
              }}
            >
              <Text small>{item.text}</Text>
              <FadedText small> by {item.author}</FadedText>
            </EventsCell>
          </EventsRow>
        ))}
      </Events>
    </EventsContainer>
  )
}
